<template>
  <div class="header_container" :class="colors[this.$route.name]">
    <div class="container-shadow">
      <div class="shadow-style" :class="colors[this.$route.name]"></div>
    </div>
    <div class="header_gradient"></div>
    <div class="header-content" :class="this.$route.name != 'Home' ? 'flex-nowrap' : ''">
      <section class="child_info">
        <div class="child_name">
          <img v-if="avatarImage" :src="avatarImage" class="avatar-image" />
          <img v-else src="@/assets/profile-pic.png" />
          <label :class="this.$route.name != 'Home' ? 'hide' : ''">{{ getUserName }}</label>
        </div>
        <div class="buttons">
          <div class="child_name" @click="goParent()" style="cursor:pointer">
            <img src="@/assets/icons/navbar/ParentView.svg" />
            <label class="label-parent-view">Go to Parent View</label>
          </div>
          <button class="userInfo-button">
            <notifications />
          </button>
        </div>
      </section>
      <headerTitle
        class="headerTitle"
        v-if="this.$route.name != 'Home'"
        :class="this.$route.name != 'Home' ? 'submenu' : ''"
      />
      <ExperienceBar
        class="xpBar"
        v-if="this.$route.name == 'Home'"
        :percentage="percentageScore"
        :title="nearestBadge ? nearestBadge.name : ''"
        :description="nearestBadge ? nearestBadge.description : ''"
        :level="getUserLevel"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import headerTitle from '@/components/header/menuTitle.vue';
import ExperienceBar from '@/components/header/ExperienceBar.vue';
import notifications from '@/components/general/notificationsDropdown.vue';
export default {
  components: {
    headerTitle,
    ExperienceBar,
    notifications,
  },
  props: {
    settings: Boolean,
  },
  data() {
    return {
      nearestBadge: null,
      colors: {
        Badges: 'badges-color',
        challengeChildApprove: 'challenges-color',
        Rewards: 'rewards-color',
        Progress: 'progress-color',
      },
    };
  },
  computed: {
    ...mapGetters('badges', ['getLockedBadges']),
    ...mapGetters('user', [
      'getUserName',
      'userIsAParent',
      'getUserScore',
      'getUserScoreAll',
      'getUserLevel',
      'getParentData',
      'getUserAvatar',
      'getOriginalParentId',
    ]),
    avatarImage() {
      const userAvatarObject = this.getUserAvatar;
      return userAvatarObject && userAvatarObject.image ? userAvatarObject.image : null;
    },
    percentageScore() {
      return this.nearestBadge && this.nearestBadge.score
        ? (this.nearestBadge.score / this.nearestBadge.score_requirement) * 100
        : 0;
    },
  },
  methods: {
    ...mapMutations('user', ['setUserType', 'setUserData']),
    ...mapActions('user', ['getUserData']),
    goParent() {
      if (this.$route.name == 'Home') {
        this.setUserType('parent');
        this.getUserData({ userIsAparent: true, userId: this.getOriginalParentId }).then(() => {
          location.reload();
        });
      } else {
        this.$router
          .push({ name: 'Home' })
          .then(() => {
            this.setUserType('parent');
            this.getUserData({ userIsAparent: true, userId: this.getOriginalParentId }).then(() => {
              window.location.href = '/';
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getNearestBadge(badges) {
      if (this.$route.name == 'Home') {
        badges.forEach((badge) => {
          if (!this.nearestBadge) {
            this.nearestBadge = badge;
          }
          const scoreDifference = badge.score_requirement - badge.score;
          const majorScoreDifference =
            this.nearestBadge.score_requirement - this.nearestBadge.score;
          if (
            scoreDifference >= 0 &&
            majorScoreDifference >= 0 &&
            scoreDifference < majorScoreDifference
          ) {
            this.nearestBadge = badge;
          }
        });
      }
    },

    testMethod() {
      return this.colors;
    },
  },
  mounted() {
    this.getNearestBadge(this.getLockedBadges.progressive_badges);
  },
};
</script>
<style scoped lang="scss">
* {
  position: relative;
}

.avatar-image {
  object-fit: cover;
  border-radius: 23px;
  min-width: 46px;
  width: 46px;
  max-width: 46px;
  min-height: 46px;
  height: 46px;
  max-height: 46px;
}

.header_container {
  background: #57b8ff;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  border-radius: 0px 0px 20px 20px;
}

.header-content {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2%;
  padding: 20px;
  // height: 190px;
  height: fit-content;
  width: 100%;
  max-width: 1366px;
}

.header-style {
  position: absolute;
  width: 100%;
  height: 100%;
  align-self: flex-start;
}

.header-background {
  position: absolute;
  width: 100%;
  height: 50%;
  object-fit: fill;
}

.header_gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background: transparent
    linear-gradient(
      90deg,
      var(--unnamed-color-ffffff) 0%,
      #ffffffad 38%,
      #ffffff5b 67%,
      #ffffff00 100%
    )
    0% 0% no-repeat padding-box;
  background: transparent
    linear-gradient(90deg, #ffffff 0%, #ffffffad 38%, #ffffff5b 67%, #ffffff00 100%) 0% 0% no-repeat
    padding-box;
  border-radius: 0px 20px 20px 20px;
  opacity: 0.64;
  z-index: 0;
}

.container-shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
}

.shadow-style {
  background: #57b8ff;
  mix-blend-mode: multiply;
  position: absolute;
  left: -12.5%;
  width: 125%;
  height: 50%;
  border-bottom-left-radius: 100%;
  border-bottom-right-radius: 100%;
  opacity: 0.5;
}

.challenges-color {
  background-color: var(--color-challenges);
}

.badges-color {
  background-color: var(--color-badges);
}

.rewards-color {
  background-color: var(--color-rewards);
}

.progress-color {
  background-color: var(--color-progress);
}

.headerTitle {
  flex-grow: 20;
}

.xpBar {
  align-self: flex-end;
  flex-grow: 20;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.userInfo-button {
  background-color: rgba(255, 255, 255, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 25px;
  &:focus {
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
  }
}

.label-parent-view {
  font-size: 1rem;
  cursor: inherit;
  @media (min-width: 550px) {
    font-size: 1.2rem;
  }
}

.hide {
  @media (max-width: 550px) {
    display: none;
  }
}

.child_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 820px) {
    flex-grow: 1;
    max-width: none;
  }
}

.child_info > * {
  margin: 5px;
}

.child_name {
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.25);
  font-size: 30px;
  color: black;
  padding: calc(1.25vw);
  border-radius: 50px;
  gap: 15px;
  & > label {
    margin: 0;
    margin-right: 15px;
  }

  img {
    width: 46px;
    aspect-ratio: 1;
  }
}

.child_name > label {
  font-weight: 400;
}

.notification_icon {
  transform: scale(1.2);
}

.text-points {
  font-size: 2.5em;
  line-height: 1em;
}
.text-stars {
  font-size: 4em;
  line-height: 1em;
}
.icon-star {
  width: 2.5em;
}
.icon-star-small {
  width: 1em;
}
</style>
